// export const updateUrlParam = (page) => {
//     const url = new URL(window.location);
    
//     // Extract the current hash (without the leading '#')
//     const hash = url.hash.split('?')[0].replace('#', ''); // Get part before the '?'
    
//     // Rebuild the hash with the new 'page' query parameter
//     const newHash = `${hash}?page=${page}`;

//     // Update the URL with the new hash and query parameter, avoiding extra #
//     window.history.pushState({}, '', `${url.pathname}${url.search}#${newHash}`);

//     // Update the current page in the component
//     return page;
// }

export const updateUrlParam = (params) => {

    console.log('params',params)
    const url = new URL(window.location);

    // Extract the current hash (without the leading '#')
    const hash = url.hash.split('?')[0].replace('#', ''); // Get part before the '?'

    // Loop through the params object and set/remove search parameters
    Object.keys(params).forEach(key => {
        const value = params[key];
        if (value === '' || value === null || typeof value === 'undefined') {
            url.searchParams.delete(key);
        } else {
            url.searchParams.set(key, value);
        }
    });

    // Rebuild the hash with the new parameters
    const newHash = `${hash}?${url.searchParams.toString()}`;
    console.log(newHash)

    // Update the URL with the new hash and parameters, avoiding extra #
    window.history.pushState({}, '', `${url.pathname}#${newHash}`);
}
